"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Address = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.text.secondary
}));
const Address = ({
  forceSingleLine,
  addressFormat,
  ...address
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const addressLines = (0, _react.useMemo)(() => (addressFormat?.lines ?? []).map(({
    fields,
    separators
  }, row, arr) => {
    // Add separators
    const items = fields.flatMap((field, index) => {
      const addressLineItem = Object.entries(address).find(e => e[0].toLocaleLowerCase() === field.toLocaleLowerCase())?.[1];
      const separator = separators[index + 1];
      if (!addressLineItem || separator === undefined) {
        return [];
      }
      return [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        ...getTestIdProps(`${_models.TestId.DeliveryBox}-${field}`),
        children: addressLineItem
      }, field), separator];
    });

    // Skip line if empty
    if (items.length === 0) {
      return null;
    }
    if (forceSingleLine) {
      return (/*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key -- index is fine here
        (0, _jsxRuntime.jsxs)("span", {
          children: [separators[0], items, row < arr.length - 1 && ', ']
        }, row)
      );
    }
    return (/*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key -- index is fine here
      (0, _jsxRuntime.jsxs)("div", {
        children: [separators[0], items]
      }, row)
    );
  }), [addressFormat?.lines, forceSingleLine, address, getTestIdProps]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    children: addressLines
  });
};
exports.Address = Address;